import { FunctionComponent, useState, ReactNode } from 'react'

interface HoverableElementProps {
  className?: string
  children: (hovered: boolean) => ReactNode
}

const HoverableElement: FunctionComponent<HoverableElementProps> = ({
  className,
  children,
}) => {
  const [hovered, setHovered] = useState(false)

  const handleMouseEnter: VoidFunction = () => {
    setHovered(true)
  }
  const handleMouseLeave: VoidFunction = () => {
    setHovered(false)
  }

  return (
    <div
      className={className}
      role='button'
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children(hovered)}
    </div>
  )
}

export default HoverableElement
